import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import Holiday from "../../main/hr/holiday/page";
import MyAttendanceReports from "../../main/staff/attendanceReports/page";
import SalaryReport from "../../main/payroll/innerScreens/salaryReport/page";

const staffRoute = [
  {
    path: "/staff/staff-holidays",
    element: <Holiday />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/staff/attendance-reports",
    element: <MyAttendanceReports />,
  },
  {
    path: "/staff/payroll",
    element: <SalaryReport />,
    module: "payroll",
    subModule: "salary-report",
  },
];

export default function renderStaffRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            ></ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return staffRoute.map((route) => renderRoute(route));
}
